import { Injectable } from '@angular/core';
import { AgencyBranding } from './agency-branding';
import { ColorGeneratorService } from './color-generator.service';

@Injectable()
export class AgencyBrandingService {

  constructor(private colorGeneratorService: ColorGeneratorService) { }

  async getBrandingDetails(hostName: string): Promise<Response> {
    return await fetch(`/EzLynxCustomerService/v1/agency-branding/${hostName}`);
  }

  async getAgencyBranding(): Promise<AgencyBranding> {
    const hostName = this.getHostName();
    const agencyBranding = JSON.parse(window.localStorage.getItem(`agencyBrandingDetails-${hostName}`));
    if (!agencyBranding) {
      const response = await this.getBrandingDetails(hostName);
      if (response.ok) {
        const branding = await response.clone().json() as AgencyBranding;
        window.localStorage.setItem(`agencyBrandingDetails-${hostName}`, JSON.stringify(branding));
        this.colorGeneratorService.setPrimary(branding?.primaryColor);
        this.colorGeneratorService.setSecondary(branding?.secondaryColor);
        return branding;
      }
      return null;
    }
    this.colorGeneratorService.setPrimary(agencyBranding?.primaryColor);
    this.colorGeneratorService.setSecondary(agencyBranding?.secondaryColor);
    return agencyBranding;
  }

  getHostName() {
    if (window.location.pathname.includes('web')) {
      return window.location.pathname.split('/')[3];
    }
    return window.location.pathname.split('/')[2];
  }
}
